import {SystemPromptStore} from "./store/SystemPromptStore";
import {systemPromptComponent, SystemPromptComponent} from "./component/SystemPromptComponent";
import {openAccountPrompt, OpenAccountPrompt} from "./components/open-account/OpenAccountSystemPromptComponent";
import {openAccountQuizPrompt, OpenAccountQuizPrompt} from "./components/open-account-quiz/OpenAccountQuizSystemPromptComponent";
import {DelayedPricePrompt, delayedPricePrompt} from "./components/delayed-price/DelayedPriceSystemPromptComponent";
import {tempMessagePrompt, TempMessagePrompt} from "./components/temp-message/TempMessagePromptComponent";
import {TrialExpiringPrompt, trialExpiringPrompt} from "./components/trial-expiring/TrialExpiringSystemPromptComponent";
import {
    tempAndDelayedPricePrompt,
    TempAndDelayedPricePrompt
} from "./components/temp-and-delayed-price-message/TempAndDelayedPriceMessagePromptComponent";
import {
    noSubscriptionPrompt,
    NoSubscriptionPrompt
} from "./components/no-subscription/NoSubscriptionSystemPromptComponent";
import {swiftStartedPrompt, SwiftStartedPrompt} from "./components/swift-started/SwiftStartedSystemPromptComponent";
import {maintenancePrompt, MaintenancePrompt} from "./components/maintenance/MaintenancePromptComponent";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.system-prompts`;

    return angular.module(moduleName, [])
                  .component(SystemPromptComponent, systemPromptComponent())
                  .component(OpenAccountPrompt, openAccountPrompt())
                  .component(OpenAccountQuizPrompt, openAccountQuizPrompt())
                  .component(DelayedPricePrompt, delayedPricePrompt())
                  .component(TempMessagePrompt, tempMessagePrompt())
                  .component(TempAndDelayedPricePrompt, tempAndDelayedPricePrompt())
                  .component(TrialExpiringPrompt, trialExpiringPrompt())
                  .component(NoSubscriptionPrompt, noSubscriptionPrompt())
                  .component(SwiftStartedPrompt, swiftStartedPrompt())
                  .component(MaintenancePrompt, maintenancePrompt())
                  .service(SystemPromptStore.id, SystemPromptStore)
                  .name;
}
